/* Stas added */
document.addEventListener('page:loaded', function() {
  console.log('Page has loaded and theme assets are ready');
  const ratingCount = document.querySelectorAll('.rating-count');
  const productReviews = document.querySelectorAll('#judgeme_product_reviews');
  if ( ratingCount.length > 0 && productReviews.length > 0 ) {
    let ratingCountHtml = ratingCount[0].innerHTML;
    ratingCount[0].innerHTML = '<a class="link cursor-pointer">' + ratingCountHtml + '</a>';
    const a = document.querySelector('.rating-count a');
    a.addEventListener("click", function(){
      scrollToSection('judgeme_product_reviews')
    });
  }

  function scrollToSection(sectionId) {
    var topBarHeight = document.querySelector('.topbar-section').offsetHeight;
    var headerHeight = document.querySelector('.header-sticky').offsetHeight;
    var section = document.getElementById(sectionId);
    if (section) {
      var rect = section.getBoundingClientRect();
      var sectionOffset = rect.top + window.pageYOffset - headerHeight - topBarHeight;
      window.scrollTo({ top: sectionOffset, behavior: 'smooth' });
    }
  }
});



/* ------------------------------------------------------------------
 * Sticky buy button → persistent top bar (MOBILE ONLY, < 768px)
 * Desktop keeps the theme's default sticky buy button.
 * - Keeps the header (menu, search, cart) visible and pins the bar directly
 *   under it. The bar slides in after the shopper scrolls ~120px.
 * - Shows the price for the selected variant AND selling plan (Recharge
 *   subscription). When a product has subscriptions, the subscription
 *   price is shown by default until the customer picks one-time.
 *   (Plan name is not shown, only the price.)
 * ------------------------------------------------------------------ */
(function () {
  function init() {
    var bar = document.querySelector('sticky-buy-button.sticky-buy-button');
    if (!bar || bar.dataset.sbbReady) return;
    bar.dataset.sbbReady = '1';
 
    var formId = bar.getAttribute('form');
    var header = document.querySelector('.header-section');
    var section = bar.closest('.shopify-section');
 
    var mq = window.matchMedia('(max-width: 767px)');
    function isMobile() { return mq.matches; }
 
    /* ---------- position + spacing ---------- */
    function positionBar() {
      if (!isMobile()) return;
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      bar.style.setProperty('--sbb-top', top + 'px');
    }
    // The bar overlays the page once it appears, so no extra page padding is needed
    function padSection() {
      if (section) section.style.paddingTop = '';
    }
 
    /* ---------- show after a short scroll ---------- */
    var SHOW_AFTER = 120; // px scrolled before the bar slides in
    function toggleBar() {
      bar.classList.toggle('sbb-visible', isMobile() && window.scrollY > SHOW_AFTER);
    }
    /* ---------- keep the header visible on mobile ----------
       The theme hides the header while scrolling down (adds .header-hidden).
       On mobile product pages with this bar, keep the header (menu, search, cart) showing. */
    function keepHeader() {
      if (header && isMobile() && header.classList.contains('header-hidden')) header.classList.remove('header-hidden');
    }
    if (header) new MutationObserver(keepHeader).observe(header, { attributes: true, attributeFilter: ['class'] });
 
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { positionBar(); toggleBar(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', function () { positionBar(); padSection(); });
    if (window.ResizeObserver) new ResizeObserver(padSection).observe(bar);
    positionBar();
    padSection();
    toggleBar();
 
    /* ---------- price (variant + selling plan) ---------- */
    var priceBox = bar.querySelector('[id^="StickyPrice-"]');
    if (!priceBox) return;
    var themePriceHtml = priceBox.innerHTML; // theme's own markup, restored on desktop
 
    var moneyFormat = (window.theme && theme.settings && theme.settings.moneyFormat) ||
                      (window.Shopify && Shopify.money_format) || '${{amount}}';
    function formatMoney(cents) {
      var n = cents / 100;
      function parts(dec, thou, sep) {
        var f = n.toFixed(dec).split('.');
        f[0] = f[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return f.join(sep);
      }
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, fmt) {
        switch (fmt) {
          case 'amount_no_decimals': return parts(0, ',', '.');
          case 'amount_with_comma_separator': return parts(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return parts(0, '.', ',');
          case 'amount_with_apostrophe_separator': return parts(2, "'", '.');
          default: return parts(2, ',', '.');
        }
      });
    }
 
    var product = null, planNames = {}, firstPlanId = null, startedAt = Date.now(), lastHtml = null, lastBuilt = '';
 
    function readState() {
      var form = document.getElementById(formId);
      if (!form) return null;
      var fd = new FormData(form);
      var id = fd.get('id') || (form.querySelector('[name="id"]') || {}).value;
      return { id: String(id || ''), plan: String(fd.get('selling_plan') || ''), hasPlanField: !!form.elements.namedItem('selling_plan') };
    }
 
    function render() {
      if (!isMobile()) {
        // Desktop: hand the price back to the theme
        if (lastHtml !== null && priceBox.innerHTML === lastHtml) priceBox.innerHTML = themePriceHtml;
        lastHtml = null; lastBuilt = '';
        return;
      }
      if (!product) return;
      var s = readState();
      if (!s) return;
      var v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === s.id) { v = product.variants[i]; break; }
      }
      if (!v) return;
 
      var plan = s.plan;
      // Subscription by default: while the subscription widget is still loading (no selling_plan
      // field yet, first ~3s), show the subscription price. Once it loads, follow the customer's choice.
      if (!plan && !s.hasPlanField && firstPlanId && Date.now() - startedAt < 3000) plan = firstPlanId;
 
      var alloc = null;
      if (plan && v.selling_plan_allocations) {
        for (var j = 0; j < v.selling_plan_allocations.length; j++) {
          if (String(v.selling_plan_allocations[j].selling_plan_id) === String(plan)) { alloc = v.selling_plan_allocations[j]; break; }
        }
      }
      var price = alloc ? alloc.price : v.price;
      var compare = alloc ? Math.max(v.price, alloc.compare_at_price || 0) : (v.compare_at_price || 0);
 
      var html = '<span class="sbb-price"><span class="sbb-price__now">' + formatMoney(price) + '</span>';
      if (compare > price) html += '<span class="sbb-price__compare">' + formatMoney(compare) + '</span>';
      html += '</span>';
 
      if (html !== lastBuilt || priceBox.innerHTML !== lastHtml) {
        lastBuilt = html;
        priceBox.innerHTML = html;
        lastHtml = priceBox.innerHTML;
      }
      priceBox.classList.remove('invisible');
    }
 
    // The theme re-renders the sticky price on variant change (without the plan) — put ours back.
    new MutationObserver(function () {
      if (lastHtml !== null && priceBox.innerHTML !== lastHtml) {
        themePriceHtml = priceBox.innerHTML; // keep the theme's latest version for desktop
        render();
      }
    }).observe(priceBox, { childList: true, subtree: true });
 
    // Switching between mobile and desktop widths (rotation, resizing)
    function onModeChange() { keepHeader(); positionBar(); padSection(); toggleBar(); render(); }
    if (mq.addEventListener) mq.addEventListener('change', onModeChange);
    else if (mq.addListener) mq.addListener(onModeChange);
 
    document.addEventListener('change', function () { setTimeout(render, 0); });
    document.addEventListener('click', function () { setTimeout(render, 60); });
    // Subscription widgets can change the selling_plan value without firing events
    setInterval(render, 500);
 
    var url = (location.pathname.replace(/\/$/, '')) + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        (p.selling_plan_groups || []).forEach(function (g) {
          (g.selling_plans || []).forEach(function (sp) {
            planNames[sp.id] = sp.name;
            if (!firstPlanId) firstPlanId = String(sp.id);
          });
        });
        startedAt = Date.now();
        render();
      })
      .catch(function () {});
  }
 
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
 